import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteKiloGLMFlow from 'hooks/glmFlows/useDeleteKiloGLMFlow';
import { useStaffTracking } from 'hooks/mixpanel/useStaffTracking';
import { KiloGLMFlow } from 'types';
import notificationHandler from 'utils/notifications';

const ModalDeleteKiloGLMFlow = ({
  opened,
  flow,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  flow: KiloGLMFlow;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteKiloGLMFlow();
  const { trackGLMFlowDeleted } = useStaffTracking();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    mutate(flow.kiloGlmFlowId, {
      onSuccess: () => {
        trackGLMFlowDeleted({
          flow_id: flow.kiloGlmFlowId,
          direction: 'kilo_to_glm',
          trigger: flow.trigger,
          action: flow.action,
        });
        successNotification('Trigger Flow delete success', `${flow.kiloGlmFlowId} successfully deleted.`);
      },
      onError: error => {
        errorNotification('Trigger Flow delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Trigger Flow</Title>}
      size='auto'
    >
      <Stack>
        <Text>{'Are you sure you want to delete this Flow?'}</Text>
        <Text color='dimmed'>
          This will also delete its execution history. This action cannot be undone.
        </Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalDeleteKiloGLMFlow;
